import type { ReactElement } from 'react';
import type { DealStage } from '../api/deals.client.js';

export interface PipelineBadgeProps {
  stage: DealStage;
  className?: string;
}

const STAGE_COLORS: Record<DealStage, { bg: string; text: string; border: string }> = {
  New: { bg: 'var(--color-bg, #ece7df)', text: 'var(--color-text-secondary, #6b5e4f)', border: 'var(--color-border, #ddd7cc)' }, // slate-200 equivalent
  Contacted: { bg: '#bae6fd', text: '#0369a1', border: '#7dd3fc' }, // sky-300 equivalent
  Negotiation: { bg: '#fde047', text: '#854d0e', border: '#fde047' }, // amber-300 equivalent
  Won: { bg: '#34d399', text: '#065f46', border: '#34d399' }, // emerald-400 equivalent
  Lost: { bg: '#fda4af', text: '#9f1239', border: '#fda4af' }, // rose-300 equivalent
};

export function PipelineBadge({ stage, className = '' }: PipelineBadgeProps): ReactElement {
  const colors = STAGE_COLORS[stage];

  return (
    <span
      className={`rounded-full font-medium ${className}`}
      style={{
        fontSize: 11,
        padding: '2px 10px',
        backgroundColor: colors.bg,
        color: colors.text,
        border: `1px solid ${colors.border}`,
      }}
    >
      {stage}
    </span>
  );
}
